module.exports = __webpack_public_path__ + "static/media/ond-loader-two.9f754f08.svg";